import { render, staticRenderFns } from "./dataSourceConfig.vue?vue&type=template&id=b4b02a90&scoped=true"
import script from "./dataSourceConfig.vue?vue&type=script&lang=js"
export * from "./dataSourceConfig.vue?vue&type=script&lang=js"
import style0 from "./dataSourceConfig.vue?vue&type=style&index=0&id=b4b02a90&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b02a90",
  null
  
)

export default component.exports